// CSS
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>
        Vinted clone - Development React, express & node Js by
        <a href="https://github.com/bmariem" target="_blank" rel="noreferrer">
          Mariem Belgacem
        </a>
      </p>
    </div>
  );
};

export default Footer;
